import Class from './chart-sphere-tones-bar';
import './chart-sphere-tones-bar@';

export default Class;